function randomIntInclusive(min = 0, max = 0) {
  const safeMin = Math.max(0, Number.isFinite(Number(min)) ? Number(min) : 0);
  const safeMax = Math.max(safeMin, Number.isFinite(Number(max)) ? Number(max) : safeMin);

  if (safeMin === safeMax) {
    return safeMin;
  }

  return Math.floor(Math.random() * (safeMax - safeMin + 1)) + safeMin;
}

function getGlobalFrontendDelayConfig() {
  return window.growtype_chat_ajax?.frontend_delays || {};
}

function getChatFrontendDelayConfig(chatForm) {
  if (!chatForm || !chatForm.length) {
    return getGlobalFrontendDelayConfig();
  }

  const chatId = chatForm.attr("id");
  const chatConfig = chatId ? window.growtype_chat?.[chatId] : null;

  return chatConfig?.frontend_delays || getGlobalFrontendDelayConfig();
}

export function getMessageFrontendDelayCase(messageData = {}, fallbackCase = "default") {
  if (typeof messageData?.frontend_delay_case === "string" && messageData.frontend_delay_case.length) {
    return messageData.frontend_delay_case;
  }

  if (messageData?.disable_frontend_delays === true) {
    return "immediate";
  }

  return fallbackCase;
}

export function getFrontendDelayPreset(chatForm, caseName = "default") {
  const config = getChatFrontendDelayConfig(chatForm);
  const presets = config?.presets || {};
  const defaultCase = config?.default_case || "default";

  return (
    presets?.[caseName] ||
    presets?.[defaultCase] ||
    presets?.default ||
    {}
  );
}

export function getSubmitDebounceDelay(chatForm, caseName = "default") {
  const preset = getFrontendDelayPreset(chatForm, caseName);
  const value = Number(preset?.submit_debounce_ms);

  return Number.isFinite(value) && value >= 0 ? value : 0;
}

function normalizeRangeConfig(rangeConfig = {}) {
  if (rangeConfig?.mode === "fixed") {
    return {
      mode: "fixed",
      value: Math.max(0, Number(rangeConfig?.value) || 0),
    };
  }

  const min = Math.max(0, Number(rangeConfig?.min) || 0);
  const max = Math.max(min, Number(rangeConfig?.max) || min);

  return {
    mode: "range",
    min,
    max,
  };
}

function resolveNamedLoaderRange(loaderDelayConfig = {}, category = "text") {
  if (loaderDelayConfig?.mode) {
    return normalizeRangeConfig(loaderDelayConfig);
  }

  const isMediaCategory = ["image", "video", "audio"].includes(category);

  if (loaderDelayConfig?.[category]) {
    return normalizeRangeConfig(loaderDelayConfig[category]);
  }

  if (isMediaCategory && loaderDelayConfig?.media) {
    return normalizeRangeConfig(loaderDelayConfig.media);
  }

  if (!isMediaCategory && loaderDelayConfig?.text) {
    return normalizeRangeConfig(loaderDelayConfig.text);
  }

  if (loaderDelayConfig?.default) {
    return normalizeRangeConfig(loaderDelayConfig.default);
  }

  return normalizeRangeConfig({});
}

export function getLoaderDelayMs(chatForm, caseName = "default", category = "text") {
  const preset = getFrontendDelayPreset(chatForm, caseName);
  const loaderRange = resolveNamedLoaderRange(preset?.loader_delay_ms || {}, category);

  if (loaderRange.mode === "fixed") {
    return loaderRange.value;
  }

  return randomIntInclusive(loaderRange.min, loaderRange.max);
}

export function getResponsePreviewDelayMs(chatForm, caseName = "default") {
  const preset = getFrontendDelayPreset(chatForm, caseName);
  const previewRange = normalizeRangeConfig(preset?.response_preview_delay_ms || {});

  if (previewRange.mode === "fixed") {
    return previewRange.value;
  }

  return randomIntInclusive(previewRange.min, previewRange.max);
}

export function getResponsePostWaitMs(chatForm, caseName = "default") {
  const preset = getFrontendDelayPreset(chatForm, caseName);
  const value = Number(preset?.response_post_wait_ms);

  return Number.isFinite(value) && value >= 0 ? value : 0;
}

export function getDynamicResponseDelayMs(chatForm, caseName = "default", response = null) {
  const preset = getFrontendDelayPreset(chatForm, caseName);
  const config = preset?.response_dynamic_delay_ms || {};

  let delay =
    randomIntInclusive(config?.base_min || 0, config?.base_max || 0);

  if (response?.data?.response_messages) {
    let totalText = "";

    response.data.response_messages.forEach((message) => {
      if (message?.html) {
        totalText += String(message.html).replace(/<[^>]*>/g, "");
      }
    });

    if (totalText.length > Number(config?.medium_threshold || 0)) {
      delay += randomIntInclusive(
        config?.medium_extra_min || 0,
        config?.medium_extra_max || 0
      );
    }

    if (totalText.length > Number(config?.long_threshold || 0)) {
      delay += randomIntInclusive(
        config?.long_extra_min || 0,
        config?.long_extra_max || 0
      );
    }
  }

  return delay;
}
